import React from 'react';
import ReactDOM from 'react-dom';

import PropTypes from 'prop-types';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import { connect, useDispatch, useSelector } from 'react-redux';

import AddActivationForm from 'components/zones/private/add/AddActivationForm/AddActivationForm';
import { AddApprovedUavosForm } from 'components/zones/private/components';
import { addLocalZone } from 'store/actions/map/allZones';
import { LOCAL_ZONES_TYPES } from 'consts/config';
import Icons from 'consts/icons';
import { userStyles } from 'consts/styles/User';
import { formStyles } from 'consts/styles/Form';
import {
  CustomStepperConnector,
  CustomStepperStepIcon,
} from 'consts/styles/Stepper';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import { Grid } from '@material-ui/core';
import FinishedInfo from './FinishedInfo/FinishedInfo';
import AddZone from '../Main';

const AddZoneForm = props => {
  const { handleCloseModal, language, allLocalZones } = props;

  const createdZone = React.useRef(null);

  const [activeStep, setActiveStep] = React.useState(0);

  const dispatch = useDispatch();

  const closeSubtitles = useSelector(state => state.language).close_;

  const classesUser = userStyles();
  const formClasses = formStyles();

  const handleClose = () => {
    handleCloseModal();
  };

  const handleAddZone = newZoneObject => {
    createdZone.current = newZoneObject;
    dispatch(addLocalZone(newZoneObject));
  };

  React.useEffect(() => {
    if (activeStep === 0 && createdZone.current) {
      setActiveStep(activeStep + 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allLocalZones]);

  const getSteps = () => [
    language.zonesDetails.addForm.createZone_,
    language.zonesDetails.addForm.addActivationPeriod_,
    language.zonesDetails.addForm.addApprovedUavos_,
    language.zonesDetails.addForm.addZoneFinished_,
  ];
  const steps = getSteps();

  return ReactDOM.createPortal(
    <div
      className={`${classesUser.User}__add-component`}
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 'calc(100vw - 30px)',
        height: '80vh',
        zIndex: 2000,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        borderRadius: 8,
        padding: 15,
        backgroundColor: 'rgba(11, 17, 32, 0.95)',
      }}
    >
      <Grid
        item
        className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between `}
      >
        <Typography
          variant="h3"
          className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
        >
          {language.zonesDetails.editZone_}
        </Typography>
        <Stepper
          className={`${formClasses.Form}__switch__stepper ${formClasses.Form}--padding-left-right`}
          activeStep={activeStep}
          connector={<CustomStepperConnector />}
        >
          {steps.map(label => (
            <Step key={label}>
              <StepLabel
                StepIconComponent={CustomStepperStepIcon}
                classes={{
                  label: `${formClasses.Form}__text-field`,
                  active: `${formClasses.Form}__text-field--focused`,
                  completed: `${formClasses.Form}__text-field--focused`,
                }}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <Tooltip title={closeSubtitles} placement="bottom">
          <div
            onClick={() => handleClose()}
            onKeyPress={() => handleClose()}
            role="button"
            tabIndex={0}
          >
            <div className={`${classesUser.User}__settings__close__container`}>
              <Icons.Actions.Close />
            </div>
          </div>
        </Tooltip>
      </Grid>

      <>{activeStep === 0 && <AddZone handleAddZone={handleAddZone} />}</>
      <>
        {activeStep === 1 && (
          <AddActivationForm
            setActiveStep={setActiveStep}
            activeStep={activeStep}
            createdZone={allLocalZones[
              LOCAL_ZONES_TYPES[createdZone.current.type]
            ].find(localZone => localZone.uid === createdZone.current.uid)}
          />
        )}
      </>
      <>
        {activeStep === 2 && (
          <AddApprovedUavosForm
            setActiveStep={setActiveStep}
            zoneUid={
              allLocalZones[LOCAL_ZONES_TYPES[createdZone.current.type]].find(
                localZone => localZone.uid === createdZone.current.uid
              ).uid
            }
            addRender
          />
        )}
      </>
      <>
        {activeStep === 3 && (
          <FinishedInfo handleClose={handleClose} language={language} />
        )}
      </>
    </div>,
    document.body
  );
};

AddZoneForm.propTypes = {
  handleCloseModal: PropTypes.func.isRequired,
  language: PropTypes.object.isRequired,
  allLocalZones: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  language: state.language,
  allLocalZones: state.allLocalZones,
});

export default connect(mapStateToProps)(AddZoneForm);
